'use strict';

/* globals angular */

require('./adminLoginForm');
require('./loginForm');
require('./resetPasswordForm');
require('./forgotPasswordForm');
require('./setPasswordForm');
require('./signupForm');
require('./signupFormRC');
require('./signupFormEmbed');
require('./selectOrganization');

const login = angular.module('login', [
  'common.utils',
  'common.raven',
  'login.admin',
  'login.form',
  'login.forgotPassword',
  'login.resetPassword',
  'login.setPassword',
  'login.signup',
  'login.signuprc',
  'login.signupEmbed',
  'login.selectOrganization'
]);

const CompareToDirective = require('./directives/CompareToDirective');
const LoginRoutes = require('./LoginRoutes');
const LoginService = require('./LoginService');
const LoginController = require('./LoginController');
const SocialLoginService = require('./services/SocialLoginService');
const LoginHeaderDirective = require('./directives/LoginHeaderDirective');
const LoginErrorDirective = require('./directives/LoginErrorDirective');
const SpinnerDirective = require('./directives/SpinnerDirective');
const SelectDirective = require('./directives/SelectDirective');

// ## Routing
login.config(LoginRoutes);

// ## Service
login.service('LoginService', LoginService);
login.service('SocialLoginService', SocialLoginService);

// ## Controllers
login.controller('LoginController', LoginController);

// ## Directives
login.directive('compareTo', CompareToDirective);
login.directive('loginHeader', LoginHeaderDirective);
login.directive('loginError', LoginErrorDirective);
login.directive('spinner', SpinnerDirective);
login.directive('sbSelectNative', SelectDirective);



// WEBPACK FOOTER //
// ./src/app/login/index.js